var _circle, _path, _path2, _path3;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconNavUsers = function SvgIconNavUsers(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 81.271,
    viewBox: "0 0 87.818 81.271",
    width: 87.818,
    ref: svgRef
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35.972,
    cy: 18.793,
    fill: "#fff",
    r: 16.293,
    stroke: "#11526a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1285.685 130.666a16.287 16.287 0 0 1 -24.741-.375c-17.822 5.867-22.94 24.965-22.94 31.5 10.019 5.333 55.27 6.3 68.36-.646 0-9.016-4.596-24.802-20.679-30.479z",
    fill: "#11526a",
    stroke: "#11526a",
    transform: "translate(-1237.504 -93.469)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m1335.422 127.11a23.1 23.1 0 1 0 23.1 23.1 23.1 23.1 0 0 0 -23.1-23.1z",
    fill: "#fff",
    transform: "translate(-1270.708 -92.048)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "themed-fill",
    d: "m1339.654 136.581a17.865 17.865 0 1 0 17.865 17.865 17.865 17.865 0 0 0 -17.865-17.865zm8.933 19.652h-7.146v7.146h-3.573v-7.146h-7.146v-3.573h7.146v-7.146h3.573v7.146h7.146z",
    fill: "#3393b9",
    transform: "translate(-1274.94 -96.28)"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconNavUsers, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-nav-users.8791b75c.svg";
export { ForwardRef as ReactComponent };